// Route name owned by the error-404 screen (single-screen → local consts, #878).
export const ERROR_ROUTE_NAME = {
  NOT_FOUND: 'not-found',
};
